"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _surveys = require("@survey/common/dist/actions/surveys.actions");
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _getResource = require("../../../dist/utilities/getResource");
var _resources = require("@survey/common/dist/actions/resources.actions");
var _pages = require("../../../dist/actions/pages.actions");
var _tabs = require("../../../dist/actions/tabs.actions");
var _surveys2 = require("../../../dist/actions/surveys.actions");
var _excluded = ["resources", "classes", "surveyType", "surveyTypeVal", "survey", "title", "contentText", "label", "isMulti", "onConfirm", "handleLogOff", "entitiesToExport"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      top: '-49px',
      right: '16px'
    },
    cancelButton: {
      top: '-6px',
      right: '16px'
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '24rem',
      minHeight: '20rem'
    },
    dialogContentRoot: {
      display: 'flex',
      flexDirection: 'column'
    },
    select: {
      width: 140,
      color: '#1a25ab !important'
    },
    formControl: {
      width: '51%',
      left: '24px',
      color: '#1a25ab !important',
      display: 'inline',
      paddingBottom: '0px'
    },
    actions: {
      position: 'relative'
    },
    selectTitle: {
      fontWeight: 'bold'
    }
  };
};
var Settings = /*#__PURE__*/function (_Component) {
  function Settings(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Settings);
    _this = _callSuper(this, Settings, [props]);
    _this.state = {
      value: '',
      newSurveyLanguage: '',
      entity: {},
      pages: [],
      surveyText: 'Save Survey',
      valueChanged: false,
      langChanged: false,
      zoomChanged: false,
      exportChanged: false,
      zoomLevel: 100,
      exportOption: 1,
      sT: {},
      entityPickerOpen: false
    };
    ['handleInputChange', 'handleApplyExport', 'handleConfirmExport', 'handleEntityCheck', 'handleEntityPickerClose', 'handleClose', 'handleLangChange', 'handleZoomChange', 'handleExportChange', 'handleConfirmZoom', 'handleConfirmLang'].map(function (name) {
      return _this[name] = _this[name].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(Settings, _Component);
  return (0, _createClass2["default"])(Settings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        pages = _this$props.pages,
        tabs = _this$props.tabs,
        resources = _this$props.resources;
      (0, _lodash.isEmpty)(pages) && this.props.getPages();
      (0, _lodash.isEmpty)(resources) && this.props.getResources();
      (0, _lodash.isEmpty)(tabs) && this.props.getTabs();
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "getSt",
    value: function getSt() {}
  }, {
    key: "handleClose",
    value: function handleClose() {
      var survey = this.props.survey;
      this.setState({
        newSurveyLanguage: survey.language
      });
      this.setState({
        exportOption: 1
      });
      this.props.updateExport(1);
      this.props.onClose();
    }
  }, {
    key: "handleLangChange",
    value: function () {
      var _handleLangChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var _event$target2, name, value, survey;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _event$target2 = event.target, name = _event$target2.name, value = _event$target2.value;
              survey = this.props.survey;
              this.setState({
                newSurveyLanguage: value
              });
              this.setState({
                langChanged: true
              });
              this.props.updateLanguage(value);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleLangChange(_x) {
        return _handleLangChange.apply(this, arguments);
      }
      return handleLangChange;
    }()
  }, {
    key: "handleConfirmLang",
    value: function handleConfirmLang(event) {
      var _event$target3 = event.target,
        name = _event$target3.name,
        value = _event$target3.value;
      this.props.setLanguage(this.state.newSurveyLanguage);
      this.setState({
        langChanged: false
      });
      this.handleClose();
    }
  }, {
    key: "handleExportChange",
    value: function () {
      var _handleExportChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
        var _event$target4, name, value, survey;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _event$target4 = event.target, name = _event$target4.name, value = _event$target4.value;
              survey = this.props.survey;
              this.setState({
                exportOption: value
              });
              this.setState({
                exportChanged: true
              });
              this.props.updateExport(value);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleExportChange(_x2) {
        return _handleExportChange.apply(this, arguments);
      }
      return handleExportChange;
    }()
  }, {
    key: "handleEntityCheck",
    value: function handleEntityCheck(event) {
      var entityIds = this.props.entitiesToExport;
      var changedId = event.target.value;
      var updatedEntitiesToExport = entityIds.includes(changedId) ? entityIds.filter(function (i) {
        return i != changedId;
      }) : [].concat(entityIds, [changedId]);
      this.props.updateEntitiesToExport(updatedEntitiesToExport);
    }
  }, {
    key: "handleEntityPickerClose",
    value: function handleEntityPickerClose() {
      this.setState({
        entityPickerOpen: false
      });
      this.props.updateEntitiesToExport([]);
    }
  }, {
    key: "handleApplyExport",
    value: function handleApplyExport(event) {
      var _event$target5 = event.target,
        name = _event$target5.name,
        value = _event$target5.value;
      if (this.props.survey.entities.length === 1 || this.state.exportOption === 2) {
        this.handleConfirmExport(event);
      } else {
        this.setState({
          entityPickerOpen: true
        });
      }
    }
  }, {
    key: "handleConfirmExport",
    value: function handleConfirmExport(event) {
      var _event$target6 = event.target,
        name = _event$target6.name,
        value = _event$target6.value;
      this.props.setExport(this.state.exportOption);
      this.setState({
        exportOption: 1
      }); //Set this back to one at the end of a confirm click so that when the modal opens next time, its reset

      this.setState({
        exportChanged: false
      });
      this.handleEntityPickerClose();
      this.handleClose();
    }
  }, {
    key: "handleZoomChange",
    value: function () {
      var _handleZoomChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
        var _event$target7, name, value;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _event$target7 = event.target, name = _event$target7.name, value = _event$target7.value;
              this.props.updateZoom(value);
              this.setState({
                zoomChanged: true
              });
              this.setState({
                zoomLevel: value
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleZoomChange(_x3) {
        return _handleZoomChange.apply(this, arguments);
      }
      return handleZoomChange;
    }()
  }, {
    key: "handleConfirmZoom",
    value: function handleConfirmZoom(event) {
      var _event$target8 = event.target,
        name = _event$target8.name,
        value = _event$target8.value;
      this.props.setZoom(this.state.zoomLevel);
      this.setState({
        zoomChanged: true
      });
      this.setState({
        zoomLevel: this.state.zoomLevel
      });
      this.setState({
        zoomChanged: false
      });
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        resources = _this$props2.resources,
        classes = _this$props2.classes,
        surveyType = _this$props2.surveyType,
        surveyTypeVal = _this$props2.surveyTypeVal,
        survey = _this$props2.survey,
        title = _this$props2.title,
        contentText = _this$props2.contentText,
        label = _this$props2.label,
        _this$props2$isMulti = _this$props2.isMulti,
        isMulti = _this$props2$isMulti === void 0 ? false : _this$props2$isMulti,
        onConfirm = _this$props2.onConfirm,
        handleLogOff = _this$props2.handleLogOff,
        entitiesToExport = _this$props2.entitiesToExport,
        other = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var showLogOff = process.env.REACT_APP_AUTH0_USE_AUTH === 'true';
      var languages = [];
      if (surveyTypeVal && surveyTypeVal.languageOptions && surveyTypeVal.languageOptions.length > 0) {
        surveyTypeVal.languageOptions.map(function (language) {
          languages.push({
            label: language,
            value: language
          });
        });
      } else {
        languages.push({
          label: 'English',
          value: 'English'
        });
      }
      var surveyLanguage = '';
      if (survey && survey.entities) {
        surveyLanguage = survey.language === null || survey.language === '' || survey.language === undefined ? 'English' : survey.language;
      }
      var showLangDialog = true;
      if (process.env.REACT_APP_DOD) {
        showLangDialog = false;
      }
      delete other.updateZoom;
      delete other.setZoom;
      delete other.zoomLevel;
      delete other.updateLanguage;
      delete other.setLanguage;
      delete other.newLang;
      delete other.updateExport;
      delete other.setExport;
      delete other.exportOption;
      delete other.newSurveyLanguage;
      delete other.getSurvey;
      delete other.getSurveyScore;
      delete other.getSurveyType;
      delete other.getUserSurveys;
      delete other.getPages;
      delete other.getTabs;
      delete other.getResources;
      delete other.saveSurvey;
      delete other.staticContext;
      delete other.updateEntitiesToExport;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        onClose: this.handleClose,
        "aria-labelledby": "settings-dialog"
      }, other, {
        PaperProps: {
          style: {
            position: 'absolute',
            top: '25px',
            right: '-19px'
          }
        }
      }), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, title), /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        className: classes.formControl
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.selectTitle
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Zoom Setting')), /*#__PURE__*/_react["default"].createElement(_material.Select, {
        className: classes.langSelect,
        value: this.props.zoomLevel === '' || this.props.zoomLevel === undefined ? 100 : this.props.zoomLevel,
        onChange: this.handleZoomChange,
        MenuProps: {
          classes: {
            paper: classes.dropdownStyle
          }
        },
        inputProps: {
          name: 'zoomLevel'
        },
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        key: '100%',
        value: 100
      }, '100%'), /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        key: '120%',
        value: 120
      }, '120%'))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
        className: classes.actions
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: this.handleConfirmZoom,
        disabled: !this.state.zoomChanged
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Apply'))), surveyType.name !== 'DIAM' && showLangDialog && /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        className: classes.formControl
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.selectTitle
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Language Select (beta)')), /*#__PURE__*/_react["default"].createElement(_material.Select, {
        className: classes.langSelect,
        value: this.props.newLang === '' || this.props.newLang === undefined || this.props.newLang === null ? surveyLanguage : this.props.newLang,
        onChange: this.handleLangChange,
        MenuProps: {
          classes: {
            paper: classes.dropdownStyle
          }
        },
        inputProps: {
          name: 'newSurveyLanguage'
        },
        fullWidth: true
      }, languages.map(function (uniqueVendor) {
        return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
          key: "".concat(uniqueVendor.value),
          value: uniqueVendor.value
        }, uniqueVendor.label);
      }))), showLangDialog && /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
        className: classes.actions
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: this.handleConfirmLang,
        disabled: !this.state.langChanged
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Apply'))), /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        className: classes.formControl
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.selectTitle
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Generate PDF')), /*#__PURE__*/_react["default"].createElement(_material.Select, {
        className: classes.langSelect,
        value: this.props.exportOption === '' || this.props.exportOption === undefined ? 1 : this.props.exportOption,
        onChange: this.handleExportChange,
        MenuProps: {
          classes: {
            paper: classes.dropdownStyle
          }
        },
        inputProps: {
          name: 'exportOption'
        },
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        key: (0, _getResource.getResource)(resources, survey.language, 'Label', 'Includes Completed Answers'),
        value: 1
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Includes Completed Answers')), /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        key: (0, _getResource.getResource)(resources, survey.language, 'Label', 'Blank Survey'),
        value: 2
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Blank Survey')))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
        className: classes.actions
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: this.handleApplyExport,
        disabled: false
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Apply'))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
        style: {
          paddingBottom: "10px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.cancelButton,
        onClick: this.handleClose
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Cancel'))), showLogOff && /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.cancelButton,
        onClick: handleLogOff
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Log Off')))), /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        fullWidth: true,
        maxWidth: "md",
        open: this.state.entityPickerOpen,
        onClose: this.handleEntityPickerClose
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, null, (0, _getResource.getResource)(resources, survey.language, 'Message', 'Select Surveys to Export')), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        component: "div"
      }, survey && survey.entities && survey.entities.length > 10 && /*#__PURE__*/_react["default"].createElement("span", null, (0, _getResource.getResource)(resources, survey.language, 'Message', 'Select up to ten surveys to export')), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, null, survey && survey.entities && survey.entities.filter(function (entity) {
        return entity.parentEntityID != null;
      }).map(function (entity) {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, null),
          disabled: _this2.props.entitiesToExport.length > 9 && !_this2.props.entitiesToExport.includes(entity.entityID.toString()),
          key: entity.entityID,
          label: entity.entityName,
          onChange: _this2.handleEntityCheck,
          value: entity.entityID
        });
      })))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        onClick: this.handleEntityPickerClose
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Cancel')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleConfirmExport,
        disabled: this.props.entitiesToExport.length === 0
      }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Apply')))));
    }
  }]);
}(_react.Component);
Settings.propTypes = {
  title: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  contentText: _propTypes["default"].string.isRequired,
  isMulti: _propTypes["default"].bool,
  survey: _propTypes["default"].object.isRequired,
  surveyType: _propTypes["default"].object.isRequired,
  updateZoom: _propTypes["default"].func,
  setZoom: _propTypes["default"].func
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    survey: state.surveys.get('survey'),
    surveyType: state.surveys.get('surveyType'),
    surveys: state.surveys.get('mySurveys'),
    pages: state.pages.get('pages'),
    tabs: state.tabs.get('tabs'),
    resources: state.resources.get('resources'),
    newSurveyLanguage: state.newSurveyLanguage
  };
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
  getSurvey: _surveys.getSurvey,
  getSurveyScore: _surveys2.getSurveyScore,
  getSurveyType: _surveys.getSurveyType,
  getUserSurveys: _surveys.getUserSurveys,
  getPages: _pages.getPages,
  getTabs: _tabs.getTabs,
  getResources: _resources.getResources,
  saveSurvey: _surveys.saveSurvey
})((0, _reactRouterDom.withRouter)(Settings)));